import { render, staticRenderFns } from "./BillQuickFoodOrder.vue?vue&type=template&id=35a0fa0e&scoped=true"
import script from "./BillQuickFoodOrder.vue?vue&type=script&lang=js"
export * from "./BillQuickFoodOrder.vue?vue&type=script&lang=js"
import style0 from "./BillQuickFoodOrder.vue?vue&type=style&index=0&id=35a0fa0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a0fa0e",
  null
  
)

export default component.exports